export default function (name) {
  // console.log('dddname;',name);
  const arr = name.split("|")
  // console.log('dddnamearr;',arr);
  return name.split("|")
}